"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleModelDeserialize = void 0;
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
function vehicleModelDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        make: (0, deserializeString_1.deserializeString)(object.make),
        name: (0, deserializeString_1.deserializeString)(object.name),
        year: (0, deserializeNumber_1.deserializeNumber)(object.year),
    };
}
exports.vehicleModelDeserialize = vehicleModelDeserialize;
